import { EventPanelView } from '@mark43/cad-api';
import React from 'react';

export type RefreshEventPanel = (options: { eventPanelView: EventPanelView }) => void;

const RefreshEventPanelContext = React.createContext<RefreshEventPanel>(() => {});

export function RefreshEventPanelProvider(props: {
    children: React.ReactNode;
    value: RefreshEventPanel;
}): React.ReactElement {
    return (
        <RefreshEventPanelContext.Provider value={props.value}>
            {props.children}
        </RefreshEventPanelContext.Provider>
    );
}

export function useRefreshEventPanel(): RefreshEventPanel {
    const refreshEventPanel = React.useContext(RefreshEventPanelContext);
    return refreshEventPanel;
}
